const orderType = {
  anixeTourism: "anixe_tourism",
  internationalTourismTravelplanet: "international_tourism_travelplanet",
  internationalTourismOther: "international_tourism_other",
};

export const tourismOrderTypes = [
  orderType.anixeTourism,
  orderType.internationalTourismTravelplanet,
  orderType.internationalTourismOther,
];

export default orderType;
